export default "__VITE_ASSET__CvRWCpLy__"